module.exports = __webpack_public_path__ + "static/media/border-dash.41c618b6.svg";